var valid;

export const UseValidation = (validRef) => {
  valid = validRef;
};

export const text_validation = (id, e, set_err) => {
  let value = e.target.value;
  let message = undefined;

  if (value.length < 3) message = "please enter at least three characters";

  set_err(message);
  valid.current.set(id, message === undefined);
};

export const password_validation = (id, e, set_err) => {
  let value = e.target.value;
  let message = undefined;

  if (value.length < 8) {
    message = "Password must be at least 8 characters long";
  } else if (!/[A-Z]/.test(value)) {
    message = "Password must contain at least one uppercase letter";
  } else if (!/[a-z]/.test(value)) {
    message = "Password must contain at least one lowercase letter";
  } else if (!/[0-9]/.test(value)) {
    message = "Password must contain at least one number";
  }

  set_err(message);
  valid.current.set(id, message === undefined);
  return message;
};

export const email_validation = (id, e, set_err) => {
  let value = e.target.value;
  let message = undefined;

  if (value.length < 3) message = "please enter at least three characters";

  // Email validation logic
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) message = "invalid email format";

  set_err(message);
  valid.current.set(id, message === undefined);
};

export const phone_validation = (id, e, set_err) => {
  let value = e.target.value.trim();
  let message = undefined;

  if (value.length > 0 && value.length < 10) message = "please enter at least 10 digits";

  // Phone number validation logic (US format: allows digits, spaces, dashes, parentheses)
  const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  if (!phoneRegex.test(value)) message = "invalid phone number format";

  if (value.length === 0) message = undefined;

  set_err(message);
  valid.current.set(id, message === undefined);
};
